import React from "react";
import { Box, Link, Typography, List, ListItem } from "@mui/material";

/**
 * Exibe orientação didática retornada pela API (listMetaPages): passos + links oficiais Meta.
 * @param {{ title?: string, summary?: string, steps?: { text: string }[], references?: { label: string, url: string }[] }} guidance
 */
export function MetaPagesGuidanceBlock({ guidance, requestId }) {
  if (!guidance || typeof guidance !== "object") return null;

  const steps = Array.isArray(guidance.steps) ? guidance.steps : [];
  const references = Array.isArray(guidance.references) ? guidance.references : [];

  return (
    <Box sx={{ mt: 0.5 }}>
      {guidance.title ? (
        <Typography variant="body2" color="error" fontWeight={600} display="block" sx={{ mb: 0.5 }}>
          {guidance.title}
        </Typography>
      ) : null}
      {guidance.summary ? (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
          {guidance.summary}
        </Typography>
      ) : null}

      {steps.length > 0 ? (
        <>
          <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" sx={{ mb: 0.5 }}>
            O que fazer:
          </Typography>
          <List dense sx={{ pl: 2, py: 0 }}>
            {steps.map((s, i) => (
              <ListItem key={i} sx={{ py: 0.25, display: "list-item" }}>
                <Typography variant="caption" color="text.secondary" component="span">
                  {i + 1}. {s.text}
                </Typography>
              </ListItem>
            ))}
          </List>
        </>
      ) : null}

      {references.length > 0 ? (
        <>
          <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" sx={{ mt: 1, mb: 0.5 }}>
            Documentação oficial Meta:
          </Typography>
          <List dense sx={{ pl: 2, py: 0 }}>
            {references.map((r, i) => (
              <ListItem key={i} sx={{ py: 0.15, display: "list-item" }}>
                <Link href={r.url} target="_blank" rel="noreferrer" sx={{ fontSize: "0.75rem" }}>
                  {r.label}
                </Link>
              </ListItem>
            ))}
          </List>
        </>
      ) : null}

      {requestId ? (
        <Typography variant="caption" color="text.disabled" display="block" sx={{ mt: 1 }}>
          ID da requisição (suporte): {requestId}
        </Typography>
      ) : null}
    </Box>
  );
}
